export const getProductImageUrl = (product, fallback = '') => (
  product?.image_url || product?.image || fallback
);
